import { create } from "zustand";

/**
 * When CRM legal-entity / branch refs are saved, list endpoints may return
 * different data for the same filters. Bump this so usePagedResource fetchers
 * get a new identity and refetch without a full page reload.
 */
type CrmMappingSyncState = {
  crmMappingEpoch: number;
  bumpCrmMappingEpoch: () => void;
};

export const useCrmMappingSyncStore = create<CrmMappingSyncState>((set) => ({
  crmMappingEpoch: 0,
  bumpCrmMappingEpoch: () => set((s) => ({ crmMappingEpoch: s.crmMappingEpoch + 1 })),
}));
